import { createToaster } from '@meforma/vue-toaster'

const toaster = createToaster({
  position: 'top-right',
  duration: 10000
})

export default toaster
